<template lang="html">
    <div class="form-group" :class="[col ? col : 'col-lg-12']">
        <label >{{ label }} <span v-if="required">*</span></label><br>

        <div class="form-check form-check-inline" v-for="(option, index) in options" :key="index">
            <input
                class="form-check-input"
                type="radio"
                :id="name + '_' + option.name"
                :value="option.value"
                :checked="option.value == value"
                @input="$emit('input', $event.target.value)"
            >
            <label class="form-check-label" :for="name + '_' + option.name">{{ option.label}}</label>
        </div>

        <error :error="error"></error>
    </div>
</template>

<script>
import Error from "./Error.vue"

export default {
    components: {
        Error
    },
    props: {
        label: String,
        name: String,
        value: String,
        error: Error,
        required: Boolean,
        col: String,
        options: Array,
    },
}
</script>
